import TopicTopPage, { getServerSideProps } from './index';

export { getServerSideProps };
export default TopicTopPage;
